import React from 'react'
import R from 'ramda'
import DocumentTitle from 'react-document-title'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Listing from '_/shared/components/listing'
import ResultsTable from '_/shared/components/resultsTable'
import Icon from '_/shared/components/icon'
import Pagination from '_/shared/components/pagination'
import ResultDetailModal from '_/shared/components/resultDetailModal'
import PinModal from '_/shared/components/pinModal'
import SaveSearchModal from '_/shared/components/saveSearchModal'
import { Row, Col, DropdownButton, SplitButton, ButtonToolbar, ButtonGroup, Button, MenuItem } from 'react-bootstrap'
import { ButtonLink } from 'react-router-bootstrap'
import { List } from 'immutable'
import resultSort from '_/shared/components/metadata/resultSort.json'
import getTransactionName from '_/utils/getTransactionName'

/**
 * Text results page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class TextResults extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    transactions: React.PropTypes.object.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func
  }

  static fetchData (store, { query }) {
    const url = `/${query.type.toLowerCase()}s`

    return {
      transactions: store.get(url, { ...query, limit: 14 })
    }
  }

  constructor (props, context) {
    super(props, context)
    this.setStateFromProps(props, context)
  }
  componentWillReceiveProps (...args) { this.setStateFromProps(...args) }

  setStateFromProps (props, context) {
    const { store, router } = context
    const query = router.getCurrentQuery()
    const type = query.type
    const account = props.account
    const isAg = account.getIn(['group', 'isAg'])

    let sortList = resultSort[type] || []
    sortList = sortList.filter(s => {
      let isValid = true

      if (isAg && s.value === 'perSfPx.value') isValid = false
      if (!isAg && s.value === 'perAcrePx.value') isValid = false

      return isValid
    })

    store.storage.lastSearchResult = router.makePath('results', null, query)
    store.post('~/search/lastResult', { lastResult: store.storage.lastSearchResult })

    this.state = {
      isListView: store.storage.lastResultView === 'list',
      currentId: null,
      propId: null,
      type: type,
      docIds: List((store.storage.searchIds && store.storage.searchIds.split(',')) || []),
      offset: Number(query.offset || 0),
      dir: query.dir || 'desc',
      sort: query.sort || sortList[0].value,
      isPrivate: query.isPrivate === 'true',
      sortList: sortList
    }
  }

  handleCheck (id) {
    let { docIds } = this.state
    const idx = docIds.indexOf(id)

    docIds = idx === -1 ? docIds.push(id) : docIds.splice(idx, 1)

    this.setState({ docIds })
  }

  handleCheckAll () {
    let { docIds } = this.state
    const { transactions } = this.props

    for (const transaction of transactions.get('data')) {
      const id = transaction.get('id')
      const idx = docIds.indexOf(id)
      if (idx === -1) docIds = docIds.push(id)
    }

    this.setState({ docIds })
  }

  handleUncheckAll () {
    let { docIds } = this.state
    const { transactions } = this.props

    for (const transaction of transactions.get('data')) {
      const id = transaction.get('id')
      const idx = docIds.indexOf(id)
      if (idx !== -1) docIds = docIds.splice(idx, 1)
    }

    this.setState({ docIds })
  }

  showSaveModal () {
    this.setState({
      isSaveOpen: true
    })
  }

  hideSaveModal () {
    this.setState({
      isSaveOpen: false
    })
  }

  handleChangeView () {
    const { store } = this.context
    const { isListView } = this.state
    store.storage.lastResultView = isListView || 'list'

    this.setState({
      isListView: !isListView
    })
  }

  handleDir () {
    const { dir } = this.state
    const { router } = this.context

    const query = router.getCurrentQuery()

    router.transitionTo('results', null, {
      ...query,
      dir: dir === 'asc' ? 'desc' : 'asc'
    })
  }

  handleSortItem (value) {
    const { router } = this.context

    const query = router.getCurrentQuery()

    router.transitionTo('results', null, {
      ...query,
      sort: value,
      dir: 'desc'
    })
  }

  handleModalOpen (currentId, propId) {
    this.setState({ currentId, propId })
  }

  handleModalClose () {
    this.setState({
      currentId: null,
      propId: null
    })
  }

  showPinModal () {
    this.setState({
      isPinOpen: true
    })
  }

  hidePinModal () {
    this.setState({
      isPinOpen: false
    })
  }

  renderTopButtons () {
    const { account } = this.props
    const { dir, sort, sortList, docIds, type, isPrivate, isListView } = this.state

    const sortIcon = dir === 'asc' ? 'asc' : 'desc'
    const currentSortItem = R.find(R.propEq('value', sort))(sortList)
    const idsStr = docIds.toJS().join(',')

    const isAg = account.getIn(['group', 'isAg'])

    const sortBtn = (
      <div>
        <Icon name={`fa-sort-alpha-${sortIcon}`} fixedWidth /> {currentSortItem.title}
      </div>
    )

    return (
      <div style={{ marginBottom: '10px' }}>
        <div className="pull-right">
          <ButtonToolbar>
            <ButtonGroup>
              <Button
                bsStyle="default"
                onClick={::this.showSaveModal}>
                <Icon name="fa-save" />
              </Button>
            </ButtonGroup>

            <ButtonGroup>
              <Button
                disabled={!isListView}
                bsStyle="default"
                onClick={::this.handleChangeView}>
                <Icon name="fa-th-large" />
              </Button>
              <Button
                disabled={isListView}
                bsStyle="default"
                onClick={::this.handleChangeView}>
                <Icon name="fa-list" />
              </Button>
            </ButtonGroup>

            <DropdownButton
              pullRight
              bsStyle="default"
              title="Options"
              id="dropdown-result-options">
              <MenuItem onSelect={::this.handleCheckAll}>
                Check all on this page
              </MenuItem>

              <MenuItem onSelect={::this.handleUncheckAll}>
                Uncheck all on this page
              </MenuItem>

              <MenuItem divider />

              {!isAg &&
                <MenuItem
                  href={`/results/summary?searchIds=${idsStr}&type=${type}&isPrivate=${isPrivate}`}
                  target="_blank"
                  disabled={!docIds.size}
                >
                  Generate summary {getTransactionName(type).toLowerCase()} report w/map
                </MenuItem>
              }
              <MenuItem
                href={`/results/detail?searchIds=${idsStr}&type=${type}&isPrivate=${isPrivate}`}
                target="_blank"
                disabled={!docIds.size}
              >
                Generate detailed {getTransactionName(type).toLowerCase()} report w/map
              </MenuItem>

              {type === 'Sale' &&
                <MenuItem
                  href={`/results/approach?searchIds=${idsStr}&type=${type}&isPrivate=${isPrivate}`}
                  target="_blank"
                  disabled={!docIds.size}
                >
                  Generate approach sale report
                </MenuItem>
              }

              <MenuItem onSelect={::this.showPinModal} disabled={!docIds.size}>
                Pin selected to project
              </MenuItem>

              <MenuItem
                href={`/results/export?searchIds=${idsStr}&type=${type}&isPrivate=${isPrivate}`}
                target="_blank"
                disabled={!docIds.size}
              >
                Export selected
              </MenuItem>
            </DropdownButton>

            <SplitButton
              pullRight
              onClick={::this.handleDir}
              bsStyle="default"
              title={sortBtn}
              id="dropdown-sort-options">
              {sortList.map((s,i) => (
                <MenuItem
                  key={i}
                  onSelect={this.handleSortItem.bind(this, s.value)}>
                  {s.title}
                </MenuItem>
              ))}
            </SplitButton>
          </ButtonToolbar>
        </div>

        <ButtonToolbar>
          <ButtonLink to="text-search" bsStyle="success">New search</ButtonLink>
          <ButtonLink to="text-search" query={{ refine: 1 }} bsStyle="info">Refine search</ButtonLink>
        </ButtonToolbar>
        <i>Total selected: <b>{docIds.size}</b></i>
      </div>
    )
  }

  renderDetails () {
    const { account, transactions } = this.props
    const { docIds, type, isListView } = this.state

    if (isListView) {
      return (
        <ResultsTable
          account={account}
          docIds={docIds}
          transactions={transactions}
          type={type}
          route="results"
          onCheck={::this.handleCheck}
          onModalOpen={::this.handleModalOpen} />
      )
    }

    return (
      <div>
        <Row>
          {
            transactions.get('data').map((t,i) => (
              <Col xs={6} key={i}>
                <Listing
                  isActive={docIds.indexOf(t.get('id')) !== -1}
                  transactionType={type}
                  transaction={t}
                  onModalOpen={::this.handleModalOpen}
                  onCheck={::this.handleCheck} />
              </Col>
            ))
          }
        </Row>
        {this.renderPaging()}
      </div>
    )
  }

  renderPaging () {
    const { transactions } = this.props
    const { dir, sort, offset } = this.state
    const { router } = this.context

    const query = router.getCurrentQuery()

    return (
      <Pagination
        dir={dir}
        route="results"
        sort={sort}
        offset={offset}
        list={transactions}
        query={query}
        limit={14}
      />
    )
  }

  renderModal () {
    const { transactions } = this.props
    const { docIds, type, currentId, propId } = this.state

    return (
      <ResultDetailModal
        type={type}
        docIds={docIds}
        transactionId={currentId}
        propertyId={propId}
        transactions={transactions}
        onCheck={::this.handleCheck}
        onModalClose={::this.handleModalClose} />
    )
  }

  render() {
    const { store } = this.context
    const { docIds, type, isPinOpen, isSaveOpen } = this.state

    // Keep store in sync with state
    store.storage.searchIds = docIds.toJS()

    return (
      <DocumentTitle title="Search results">
        <div>
          {this.renderTopButtons()}
          {this.renderDetails()}
          {this.renderModal()}

          <PinModal
            open={isPinOpen}
            onClose={::this.hidePinModal}
            transactionIds={List(docIds)}
            title="Add these transactions to project(s)"
            type={type} />

          <SaveSearchModal
            open={isSaveOpen}
            onClose={::this.hideSaveModal}
            title="Save search criteria" />
        </div>
      </DocumentTitle>
    )
  }
}

export default TextResults



// WEBPACK FOOTER //
// ./modules/shared/pages/search/textResults.js